import React from 'react';
import { fetchPlatformInfo } from '../../APIManager';
const ProfileStateContext = /*#__PURE__*/React.createContext();
const ProfileDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  users: []
};

/** REDUCER **/
function ProfileReducer(state, action) {
  switch (action.type) {
    case 'SET_USERS':
      return {
        ...state,
        users: action.payload
      };
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function ProfileProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(ProfileReducer, initialState);
  return /*#__PURE__*/React.createElement(ProfileStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(ProfileDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useProfileState() {
  const context = React.useContext(ProfileStateContext);
  if (context === undefined) {
    throw new Error('useProfileState must be used within a ProfileProvider');
  }
  return context;
}
function useProfileDispatch() {
  const context = React.useContext(ProfileDispatchContext);
  if (context === undefined) {
    throw new Error('useProfileDispatch must be used within a ProfileProvider');
  }
  return context;
}

/** API **/
const profileAPI = {
  getUserProfile: async (url, id, authToken) => {
    try {
      const response = await fetchPlatformInfo(url, id, authToken);
      if (!response) {
        throw new Error('Could not get user profile.');
      }
      return response;
    } catch (err) {
      return {};
    }
  }
};
export { ProfileProvider, useProfileState, useProfileDispatch, profileAPI };
//# sourceMappingURL=index.js.map